export function updateClock(setTime) {
  const now = new Date();

  const utc = now.getTime() + now.getTimezoneOffset() * 6000;
  const gmt4 = new Date(utc - 4 * 3600000);

  const year = gmt4.getFullYear();
  const month = String(gmt4.getMonth() + 1).padStart(2, '0');
  const day = String(gmt4.getDate()).padStart(2, '0');

  const hour = String(gmt4.getHours()).padStart(2, '0');
  const min = String(gmt4.getMinutes()).padStart(2, '0');
  const seconds = String(gmt4.getSeconds()).padStart(2, '0');

  setTime(`${year}/${month}/${day} ${hour}:${min}:${seconds}`);
}
